export default {
  date_sameDay: '[Today at] HH:mm',
  date_lastDay: '[Yesterday at] HH:mm',
  date_lastWeek: '[Last] dddd HH:mm',
  date_sameElse: 'DD MMMM YYYY [at] HH:mm',
  operation_type_outgoing_payment: 'Outgoing payment',
  operation_type_withdrawal: 'Withdrawal',
  operation_type_deposit: 'Deposit',
  search_campaign: 'Search crowdfunding campaign',
  signup_password: 'password',
  lbl_import_image_details: 'Minimal size: 120х120, no more than 5mb\nSupported formats: PNG, JPG, GIF, BMP',
  lbl_import_image_details_campaign: 'Minimal size: 290х170, no more than 5mb\nSupported formats: PNG, JPG, GIF, BMP',
  lbl_confirmation_sent: 'A confirmation email was sent to %{mail}. Please check your inbox to verify your account',
  lbl_check_spam: 'If you didn\'t receive a confirmation email, check your spam folder.',
  lbl_seed_dont_match: 'Wrong seed phrase',
  lbl_not_verified: 'not verified',
  pending: 'pending',
  approved: 'approved',
  rejected: 'rejected',
  tx_state_confirm: 'success',
  tx_state_success: 'success',
  tx_state_pending: 'pending',
  tx_state_failed: 'failed',
  tx_state_rejected: 'rejected',
  tx_state_fully_matched: 'fully matched',
  tx_from: 'from',
  tx_to: 'to',
  tx_issuance: 'Deposit',
  tx_investment: 'Investment',
  tx_match: 'Order match',
  tx_withdrawal: 'Withdrawal',
  tx_transfer: 'Transfer',
  tx_offer: 'Offer',
  tx_invoice: 'Invoice',
  tx_greater_than_balance: 'Amount is greater than existing balance',
  tx_blocks_separator: 'or',
  // notifications
  notification_transaction_income: 'You received a new payment on total amount of %{amount} %{asset} from %{sender_name} (%{sender_email})',
  notification_transaction_emission: 'New emission %{amount} %{asset}',
  notification_transaction_exchange: 'You successfully exchanged %{source_amount} %{source_asset} for %{amount} %{asset}',
  notification_contract_money_lock: 'Your funds %{amount} %{asset} have been reserved by invoice number %{invoice_number} contract %{contract_number}',
  notification_no_new_notifications: 'No new notifications!',
  notification_kyc_to_not_verified: 'You have been transferred to the status of an unverified user',
  notification_kyc_approve: 'Your account verification request was approved',
  notification_kyc_reject: 'Your account verification request has been rejected',
  // nav
  nav_search: 'find a project...',
  nav_not_verifying_user_msg: 'Your account has limited functionality',
  nav_go_through_verification: 'go through verification'
}



// WEBPACK FOOTER //
// ./src/js/i18n/views/en_all.js